// extracted by mini-css-extract-plugin
export default {"title":"title__R5Xs","list":"list_tieJI","item":"item_hDCTT"};